import { useTranslation } from "react-i18next";

import Button from "~/components/atoms/Button";
import Typo from "~/components/atoms/Typo";
import Section from "~/components/templates/SectionProject";
import { cn } from "~/utilities/cn";
import { SCROLL_OFFSET } from "~/utilities/constants/projectSections";
import { ETypoColor } from "~/utilities/enums/Colors";
import { Section as SectionUrl } from "~/utilities/enums/ProjectSections";
import { ETypoTag, ETypoVariant } from "~/utilities/enums/Typo";

export interface SectionScrollToEnquiryProps {
  id: string;
  title: string;
  description: string;
  className?: string;
  projectName?: string;
}

const SectionScrollToEnquiry: React.FC<SectionScrollToEnquiryProps> = ({
  id,
  title,
  description,
  className,
  projectName,
}) => {
  const { t } = useTranslation();

  const scrollEnquiryToView = (targetId: string) => {
    const sectionEl = document.getElementById(targetId);
    if (sectionEl) {
      const y =
        sectionEl.getBoundingClientRect().top + window.scrollY + SCROLL_OFFSET;
      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    }
  };

  return (
    <Section
      id={id}
      className={cn("p-0 last:mb-6 lg:px-6 lg:py-4.5", className)}
    >
      <div className="flex items-center justify-between gap-6 rounded-xl bg-projectCardGoToEnquiryBackground p-6 lg:flex-col lg:items-start lg:rounded-lg lg:p-4.5">
        <div className="flex flex-col justify-between gap-2">
          <Typo
            tag={ETypoTag.P}
            variant={ETypoVariant.HEADER_PROJECT_24}
            color={ETypoColor.PROJECT_CARD_GO_TO_ENQUIRY}
            className="font-bold"
          >
            {t(title)}
          </Typo>
          <Typo
            tag={ETypoTag.P}
            variant={ETypoVariant.SUB_TITLE_16}
            color={ETypoColor.PROJECT_CARD_GO_TO_ENQUIRY}
          >
            {t(description, {
              projectName: projectName || "",
            })}
          </Typo>
        </div>
        <Button
          className="block bg-projectCardGoToEnquiryButton hover:bg-projectCardGoToEnquiryButtonHover lg:hidden "
          variant="destructive"
          onClick={() => scrollEnquiryToView(SectionUrl.CONTACT_SALES)}
        >
          <Typo
            tag={ETypoTag.SPAN}
            variant={ETypoVariant.BODY_TITLE_16}
            color={ETypoColor.PROJECT_CARD_GO_TO_ENQUIRY_BUTTON}
            className="font-bold"
          >
            {t("project.sections.scroll_to_enquiry.cta_button")}
          </Typo>
        </Button>
        <Button
          variant="destructive"
          className="hidden bg-projectCardGoToEnquiryButton hover:bg-projectCardGoToEnquiryButtonHover lg:block lg:w-full"
          onClick={() => scrollEnquiryToView(SectionUrl.CONTACT_SALES)}
        >
          <Typo
            tag={ETypoTag.SPAN}
            variant={ETypoVariant.BODY_TITLE_16}
            color={ETypoColor.PROJECT_CARD_GO_TO_ENQUIRY_BUTTON}
            className="font-bold"
          >
            {t("project.sections.scroll_to_enquiry.cta_button")}
          </Typo>
        </Button>
      </div>
    </Section>
  );
};

export default SectionScrollToEnquiry;
